import {uploadFile} from "../../service/uploaderService/UploaderService";
import {BaseService} from "../../base/BaseService";

export class FileManagerService extends BaseService {

    constructor(loading, snackbar, token) {
        super(token, loading, snackbar)
    }


    uploadImageToServer(imageFile, publishStatus, setHideImageUploadLoading, setProgressImage, setBufferImage, fileManagerType) {
        return new Promise((resolve, reject) => {
            uploadFile(
                imageFile,
                setProgressImage,
                setBufferImage,
                setHideImageUploadLoading,
                fileManagerType.uploadUrl,
                {
                    "public-status": publishStatus
                }
            )
                .then(resolve).catch(reject)
        })
    }

    getImages(selectedFileMangerType, page, size = 15) {

        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `buckets/${selectedFileMangerType.id}/files`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }

    deleteFile(fileManagerTypes, selectedFileForDelete) {

        return new Promise((resolve, reject) => {
            this.httpClient.delete(
                `files/${selectedFileForDelete}`,
            ).then(resolve).catch(reject)
        })

    }

    getImageUrl(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `files/${id}/urls/public`,
            ).then(resolve).catch(reject)
        })
    }
}